<template>
    <div id="main">
        <div id="content">
            <v-container grid-list-x>
                <h1>Sobre mim</h1>
                <div class="body-1 mb-4">Meu nome é Anderson Rodrigo, formando em Engenharia da Computação pelo INATEL, especialista em Engenharia de Software pela UNICAMP.</div>
                <div class="body-1 mb-4">
                    Procuro sempre novos conhecimentos, seja participando de eventos, fazendo cursos ou até mesmo criando produtos para uso pessoal, além disso, busco parcerias
                    para desenvolvimento de habilidades que não são do meu dia a dia no trabalho. Atuando hoje na empresa Treetech Sistemas Digitais, como líder de projetos
                    (project owner) em que participo desde a criação até a finalização do produto, trabalho diretamente com softwares embarcados com foco em protocolos de
                    comunicação modbus, dnp3 e IEC 61850. Tenho experiência em desenvolvimento nas plataformas linux, windows, android, banco de dados e sistemas web.
                </div>
                <div class="body-1 mb-4">
                    Pessoalmente sou uma pessoa que adora a natureza, amante de 2 e 4 rodas, atualmente prático trilhas de moto, a pé e raras vezes de bicicleta. Sou muito
                    competitivo e movido por desafios.
                </div>
                <v-timeline dense>
                    <v-timeline-item color="secondary" small v-for="(item, i) in timeline" :key="i">
                        <template>
                            <span class="headline font-weight-bold secondary--text" v-text="item.date"></span>
                        </template>
                        <v-card color="secondary" dark class="elevation-2">
                            <v-card-title class="title" v-if="item.title">{{ item.title }}</v-card-title>
                            <v-card-text class="white text--primary" v-if="item.description">{{ item.description }}</v-card-text>
                        </v-card>
                    </v-timeline-item>
                </v-timeline>
            </v-container>
        </div>
    </div>
</template>

<script>
export default {
    name: "Home",
    data() {
        return {
            timeline: [
                { date: "1987", title: "Nascimento", description: "15 de outubro de 1987, eis que surge mais uma pessoa na terra." },
                {
                    date: "2004",
                    title: "Curso técnico em eletônica industrial",
                    description: "Ainda durante o ensino médio iniciei o curso técnico em eletrônica, foi onde descobri o que queria para o futuro, desenvolvimento de software.",
                },
                { date: "2006", title: "Universidade", description: "A universidade que escolhi foi o INATEL e o curso de engenheria de computação." },
                {
                    date: "2009",
                    title: "Estágio",
                    description:
                        "Aqui aprendi muito com duas grandes pessoas, Pina e Mury, que além de professores do INATEL eram sócios da empresa que me deu a opurtunidade de estágio. Com certeza foi a época de maior aprendizado na minha vida.",
                },
                { date: "2011", title: "Formatura em engenharia da computação" },
                { date: "2013", title: "DB1", description: "Ano em que fiquei fazendo transfência de conhecimento dentro de uma fábrica de software." },
                { date: "2014", title: "Treetech", description: "Mudança para Atibaia para um novo desafio." },
                { date: "2016", title: "Pós graduação em engenharia de software" },
                { date: "2020", title: "Reabertura da empresa para parcerias de desenvolvimento de software" },
            ],
        };
    },
};
</script>
